import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "illustration", "title", "type"];
import PropTypes from 'prop-types';
import { isValidElement } from 'react';
import classNames from 'classnames';
import I18n from 'I18n';
import H4 from '../elements/headings/H4';
import UIResultsMessage from '../results/UIResultsMessage';
import lazyEval from '../utils/lazyEval';
import createLazyPropType from '../utils/propTypes/createLazyPropType';
import { getIllustrationNamePropType } from '../utils/propTypes/illustrationName';
import { jsx as _jsx } from "react/jsx-runtime";
const errorTypes = {
  badRequest: {
    image: 'errors/general',
    title: () => I18n.text('ui.UIErrorMessage.badRequest.title')
  },
  error: {
    image: 'errors/general',
    title: () => I18n.text('ui.UIErrorMessage.error.title')
  },
  expired: {
    image: 'errors/hourglass',
    title: () => I18n.text('ui.UIErrorMessage.expired.title')
  },
  notFound: {
    image: 'errors/map',
    title: () => I18n.text('ui.UIErrorMessage.notFound.title')
  }
};
const errors = Object.assign({}, errorTypes, {
  '400': errorTypes.badRequest,
  '403': errorTypes.expired,
  '404': errorTypes.notFound,
  '500': errorTypes.error
});

// UIResultsMessage.defaultProps.Body = 'div'
const ErrorBody = props => /*#__PURE__*/_jsx("div", Object.assign({}, props, {
  className: "private-error-msg__body"
}));

// UIResultsMessage.defaultProps.Image = MessageImage = UIIllustration
const ErrorImage = props => /*#__PURE__*/_jsx(UIResultsMessage.defaultProps.Image, Object.assign({}, props, {
  className: "private-error-msg__image"
}));
const getErrorValues = (type = 'error') => errors[type] || errors.error;
const defaultIllustrationProps = {
  width: 175
};
const renderTitle = (title = errors['error'].title) => {
  // @ts-expect-error Formatted* components need types to detect isI18nElement
  if ( /*#__PURE__*/isValidElement(title) && title.type.isI18nElement) {
    return /*#__PURE__*/_jsx(H4, {
      className: "private-error-msg__title",
      children: title
    });
  } else if ( /*#__PURE__*/isValidElement(title)) {
    return title;
  } else {
    return /*#__PURE__*/_jsx(H4, {
      className: "private-error-msg__title",
      children: lazyEval(title)
    });
  }
};
export default function UIErrorMessage(_ref) {
  let {
      className,
      illustration,
      title,
      type
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    image,
    title: imageTitle
  } = getErrorValues(type);
  return /*#__PURE__*/_jsx(UIResultsMessage, Object.assign({}, rest, {
    className: classNames('private-error-msg', className),
    illustration: illustration || image,
    Image: ErrorImage,
    title: renderTitle(title || imageTitle)
  }));
}
UIErrorMessage.propTypes = {
  Body: PropTypes.elementType,
  children: PropTypes.node,
  illustration: getIllustrationNamePropType(),
  illustrationProps: PropTypes.object,
  title: createLazyPropType(PropTypes.oneOfType([PropTypes.node, PropTypes.string])),
  type: PropTypes.oneOf(Object.keys(errors))
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIErrorMessage.defaultProps = {
  Body: ErrorBody,
  illustrationProps: defaultIllustrationProps,
  type: 'error'
};
UIErrorMessage.displayName = 'UIErrorMessage';